export enum OrderState {
  New = 0,
  Active = 1,
  Executed = 2,
  Rejected = 3,
  Cancelled = 4,
  WaitingForConfirmation = 5,
}
